import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { queryClient } from "./app/queryClient";
import { router } from "./app/routes";
import "./i18n";
import "./global.css";

async function enableMockingIfNeeded(): Promise<void> {
  // dev server ではデフォルトで MSW を起動して mock 応答を返す。
  // 実 backend (Cloud Run stg やローカル go run) を叩きたい開発者は
  // VITE_USE_MSW=false を渡して off にする。
  if (!import.meta.env.DEV) return;
  if (import.meta.env.VITE_USE_MSW === "false") return;
  const { worker } = await import("./mocks/browser");
  await worker.start({ onUnhandledRequest: "bypass" });
}

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("root element not found");
}

void enableMockingIfNeeded().then(() => {
  createRoot(rootEl).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
});
